import { TemplateConfig } from '../types';

export const soulmate6CardsConfig: TemplateConfig = {
  id: 'soulmate-6-cards',
  name: '正缘6张牌',
  description: '分析你的正缘情况',
  cardCount: 6,
  
  fieldDefaults: {
    title: '我的正缘分析',
    customerQuestion: '**我未来的正缘的情况分析**',
    cardInfos: [
      '未来正缘的性格',
      '未来正缘的外貌和身高信息，分析时请尽量具体，如：肤色偏白、身高175左右、瓜子脸之类',
      '未来正缘的工作情况和职业类型，分析时即使目前看起来这方面信息不明显，也要给出具体的专业或行业范围，如：金融行业、计算机专业等',
      '对方的家庭情况',
      '你们相遇的方式和地点',
      '一年之内能否相遇，以及相遇的大概时间特点，比如季节或者月份'
    ],
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 1 行第 2 张牌',
      '请输入第 1 行第 3 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 2 张牌',
      '请输入第 2 行第 3 张牌'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#722ed1',
    backgroundColor: '#f9f0ff',
    icon: '💜'
  }
};